(function() {
  'use strict';

  if (window.__parentCollectionModulesLoaded) return;
  window.__parentCollectionModulesLoaded = true;

  function bindWithCleanup(target, type, handler, options, cleanups, controller) {
    if (!target) return;

    if (controller) {
      var opts = options && typeof options === 'object' ? Object.assign({}, options, { signal: controller.signal }) : { signal: controller.signal };
      target.addEventListener(type, handler, opts);
      return;
    }

    target.addEventListener(type, handler, options || false);
    cleanups.push(function() {
      target.removeEventListener(type, handler, options || false);
    });
  }

  function getHeaderHeight() {
    var header = document.querySelector('.header-section .header') || document.querySelector('.header-section');
    return header ? header.offsetHeight : 0;
  }

  function getPageTop(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return 0;
    return element.getBoundingClientRect().top + window.pageYOffset;
  }

  function initStickyNav(sectionRoot) {
    if (!sectionRoot) return;
    if (typeof sectionRoot.__parentStickyCleanup === 'function') {
      sectionRoot.__parentStickyCleanup();
    }

    var shell = sectionRoot;
    var nav = shell.querySelector('[data-parent-nav]');
    if (!shell || !nav) return;

    var tabsContainer = nav.querySelector('[data-parent-tabs]');
    var cartCount = nav.querySelector('[data-parent-cart-count]');
    if (!tabsContainer) return;

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var cleanups = [];
    var buttons = [];
    var targets = [];
    var rafId = 0;
    var lastActiveIndex = -1;

    function getSectionElement() {
      return shell.closest('.shopify-section') || shell.parentElement;
    }

    function getHeroSection() {
      var prev = getSectionElement() ? getSectionElement().previousElementSibling : null;
      while (prev && !prev.classList.contains('shopify-section')) {
        prev = prev.previousElementSibling;
      }
      return prev;
    }

    function getHeaderElement() {
      return document.querySelector('.header-section .header') || document.querySelector('.header-section');
    }

    function isHeaderHidden() {
      return document.body.classList.contains('parent-header-hidden');
    }

    function getHeaderBottom() {
      var header = getHeaderElement();
      if (!header) return 0;

      var rect = header.getBoundingClientRect();
      return Math.max(rect.bottom, header.offsetHeight || 0);
    }

    function getPinnedOffset() {
      var headerHeight = getHeaderHeight();
      return window.innerWidth >= 1024 || isHeaderHidden() ? nav.offsetHeight : headerHeight + nav.offsetHeight;
    }

    function getNavTop(shouldHideHeader) {
      return window.innerWidth >= 1024 || shouldHideHeader ? 0 : getHeaderHeight();
    }

    function setCartCountValue(count) {
      if (!cartCount || typeof count !== 'number') return;
      cartCount.textContent = count > 99 ? '99+' : String(count);
    }

    function syncCartCount() {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

      return fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('cart.js');
          return response.json();
        })
        .then(function(data) {
          setCartCountValue(data.item_count || 0);
        })
        .catch(function() {});
    }

    function getTargets() {
      return Array.prototype.slice.call(document.querySelectorAll('.parent-category-banner[data-parent-anchor-id]'));
    }

    function centerActiveButton(button) {
      if (!button) return;
      var targetLeft = Math.max(0, button.offsetLeft - (tabsContainer.clientWidth - button.offsetWidth) / 2);
      tabsContainer.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    function updateNavVisibility() {
      var hero = getHeroSection();
      if (!hero) return;

      var heroRect = hero.getBoundingClientRect();
      var headerBottom = getHeaderBottom();
      var shouldShow = heroRect.bottom <= headerBottom;

      document.body.classList.toggle('parent-header-hidden', shouldShow);
      nav.style.top = getNavTop(shouldShow) + 'px';
      nav.classList.toggle('is-visible', shouldShow);
    }

    function updateActiveState() {
      if (!targets.length || !buttons.length) return;

      var triggerLine = window.scrollY + getPinnedOffset() + 24;
      var activeIndex = -1;

      for (var i = 0; i < targets.length; i++) {
        var current = targets[i];
        var next = targets[i + 1];
        var start = getPageTop(current);
        var end = next ? getPageTop(next) : document.documentElement.scrollHeight;

        if (triggerLine >= start && triggerLine < end) {
          activeIndex = i;
          break;
        }
      }

      if (activeIndex === -1 && targets.length) {
        activeIndex = triggerLine < getPageTop(targets[0]) ? 0 : targets.length - 1;
      }

      buttons.forEach(function(button, index) {
        var isActive = index === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (activeIndex >= 0 && activeIndex !== lastActiveIndex) {
        lastActiveIndex = activeIndex;
        centerActiveButton(buttons[activeIndex]);
      }
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function() {
        rafId = 0;
        updateNavVisibility();
        updateActiveState();
      });
    }

    function buildTabs() {
      targets = getTargets();
      buttons = [];
      lastActiveIndex = -1;
      tabsContainer.innerHTML = '';

      if (!targets.length) {
        nav.hidden = true;
        nav.classList.remove('is-visible');
        document.body.classList.remove('parent-header-hidden');
        return;
      }

      nav.hidden = false;

      targets.forEach(function(target, index) {
        var label = target.getAttribute('data-parent-elevator-label') || target.getAttribute('data-parent-title') || ('Category ' + (index + 1));
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'parent-nav__tab';
        button.textContent = label;
        button.setAttribute('aria-current', 'false');
        button.addEventListener('click', function() {
          var top = target.getBoundingClientRect().top + window.pageYOffset - getPinnedOffset() - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
        tabsContainer.appendChild(button);
        buttons.push(button);
      });
    }

    function openCartDrawer() {
      var cartDrawerElement = document.getElementById('Cart-Drawer') || document.querySelector('cart-drawer');
      if (cartDrawerElement && typeof cartDrawerElement.open === 'function') {
        cartDrawerElement.open();
        return;
      }

      if (cartDrawerElement) {
        cartDrawerElement.classList.add('active');
        document.body.classList.add('open-cc');
        return;
      }

      var fallbackToggle = document.getElementById('cart-drawer-toggle');
      if (fallbackToggle) {
        fallbackToggle.click();
        return;
      }

      try {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      } catch (error) {
        window.location.href = '/cart';
      }
    }

    function handleDocumentClick(event) {
      if (event.target.closest('[data-parent-open-cart]')) {
        event.preventDefault();
        syncCartCount();
        openCartDrawer();
      }
    }

    function handleCartEvent(event) {
      if (event.detail && event.detail.cart && typeof event.detail.cart.item_count === 'number') {
        setCartCountValue(event.detail.cart.item_count);
      } else {
        syncCartCount();
      }
    }

    function handleSectionChange(event) {
      if (event.target && event.target.contains(shell)) return;
      buildTabs();
      scheduleUpdate();
    }

    function destroy() {
      document.body.classList.remove('parent-header-hidden');
      nav.classList.remove('is-visible');

      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }

      if (controller) {
        controller.abort();
      } else {
        while (cleanups.length) {
          cleanups.pop()();
        }
      }
    }

    shell.__parentStickyCleanup = destroy;

    function boot() {
      buildTabs();
      updateNavVisibility();
      updateActiveState();
      syncCartCount();
    }

    bindWithCleanup(window, 'scroll', scheduleUpdate, { passive: true }, cleanups, controller);
    bindWithCleanup(window, 'resize', scheduleUpdate, false, cleanups, controller);
    bindWithCleanup(document, 'click', handleDocumentClick, false, cleanups, controller);
    bindWithCleanup(document, 'cart:item-added', handleCartEvent, false, cleanups, controller);
    bindWithCleanup(document, 'cart:refresh', handleCartEvent, false, cleanups, controller);
    bindWithCleanup(document, 'shopify:section:load', handleSectionChange, false, cleanups, controller);
    bindWithCleanup(document, 'shopify:section:unload', handleSectionChange, false, cleanups, controller);
    bindWithCleanup(document, 'shopify:section:reorder', handleSectionChange, false, cleanups, controller);
    bindWithCleanup(document, 'shopify:section:unload', function(event) {
      if (event.target && event.target.contains(shell)) {
        destroy();
      }
    }, false, cleanups, controller);

    if (document.readyState === 'loading') {
      bindWithCleanup(document, 'DOMContentLoaded', boot, false, cleanups, controller);
    } else {
      boot();
    }
  }

  function initAll(context) {
    var scope = context || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-parent-sticky-nav-root]')).forEach(initStickyNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
